module.exports = __webpack_public_path__ + "static/media/ai_worth_3.641e7ec9.png";